import { ControlPanelState } from '@superset-ui/chart-controls';
import { JsonObject } from '@superset-ui/core';

export function getDefaultTimeFilterInDataset(
  datasource: ControlPanelState['datasource'],
): string | null {
  try {
    return (
      JSON.parse((datasource as JsonObject)?.extra ?? '{}')?.timeRange ?? null
    );
  } catch (error) {
    return null;
  }
}
